import { useEffect, useState } from 'react';

import { FormField, FormHelp, Textarea } from '@zillow/constellation-10';

type Props = {
  initialValue?: string;
  isDisabled?: boolean;
  maxLength?: number;
  // eslint-disable-next-line
  onClearError?: (value?: any) => void;
  handleCaptionBlur: (value: string) => void;
};

export const TextareaHelper = ({
  initialValue = '',
  isDisabled = false,
  maxLength = 255,
  onClearError,
  handleCaptionBlur,
}: Props) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onClearError) {
      onClearError();
    }
    setValue(e.target.value);
  };

  const handleOnBlur = () => {
    handleCaptionBlur(value);
  };

  return (
    <FormField
      css={{ marginBlock: 'tight' }}
      control={
        <Textarea
          aria-label="Image Description"
          maxLength={maxLength}
          value={value}
          onChange={handleOnChange}
          onBlur={handleOnBlur}
          disabled={isDisabled}
        />
      }
      description={<FormHelp>Max {maxLength} characters</FormHelp>}
    />
  );
};
